import React, { createContext, useReducer, useContext } from 'react';

// Define the initial state
const initialState = {
  comedicStyle: 'average', // can be 'dirty', 'clean', or 'average'
  topics: [], // you can define various topics or preferences here
};

// Reducer function to handle updating the preferences
const preferencesReducer = (state, action) => {
  switch (action.type) {
    case 'SET_STYLE':
      return { ...state, comedicStyle: action.payload };
    case 'SET_TOPICS':
      return { ...state, topics: action.payload };
    default:
      return state;
  }
};

// Create a context
const PreferencesContext = createContext();

// Custom hook to use the Preferences context
export const usePreferences = () => {
  return useContext(PreferencesContext);
};

// PreferencesProvider component to wrap around your app
export const PreferencesProvider = ({ children }) => {
  const [state, dispatch] = useReducer(preferencesReducer, initialState);

  return (
    <PreferencesContext.Provider value={{ state, dispatch }}>
      {children}
    </PreferencesContext.Provider>
  );
};
